module.exports = __webpack_public_path__ + "img/jornay-logo.8bd9e55c.svg";